<nav class="sidebar-nav" aria-label="Разделы сервиса">
    @for (section of menu().sections; track $index) {
        @if (section.title) {
            <p class="sidebar-nav__group">{{ section.title }}</p>
        }

        @for (item of section.items; track item.path) {
            <a
                class="sidebar-nav__link"
                [routerLink]="item.path"
                [attr.aria-label]="item.label"
                [matTooltip]="item.label"
                [matTooltipDisabled]="!collapsed()"
                matTooltipPosition="right"
            >
                <app-nav-icon [name]="item.icon" />
                <span class="sidebar-nav__label">{{ item.label }}</span>
            </a>
        }
    }
</nav>
